"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EditMenu = void 0;
var _imageEditing = require("../utils/imageEditing");
var _AdjustmentControls = require("./AdjustmentControls");
var _AdvancedToggle = require("./AdvancedToggle");
var _CropControls = require("./CropControls");
var _FilterSelector = require("./FilterSelector");
var _jsxRuntime = require("react/jsx-runtime");
const EditMenu = ({
  activeTab,
  cropHasChanges,
  editState,
  image,
  onAdjustmentChange,
  onCropChange,
  onFilterChange,
  onModeChange,
  onReset,
  onSave,
  onTabChange,
  saving,
  stagedCrop
}) => {
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("aside", {
    className: "edit-menu",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "edit-menu-header",
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: "row m-0",
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: "col-3 col-md-3 px-0 align-content-center",
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("h2", {
            id: "editor-title",
            className: "m-0",
            children: "Edit"
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: "col-6 col-md-9 px-0",
          children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
            className: "editor-tabs gap-1 d-flex justify-content-center justify-content-md-end",
            role: "group",
            "aria-label": "Editor actions",
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
              className: "btn bg-beige editor-icon-button",
              type: "button",
              onClick: () => onReset(_imageEditing.defaultEditState),
              "aria-label": "Reset edits",
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)("i", {
                className: "bi bi-arrow-counterclockwise"
              })
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("button", {
              className: "btn bg-green editor-icon-button",
              type: "button",
              onClick: onSave,
              disabled: saving || cropHasChanges,
              "aria-label": "Save edit",
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)("i", {
                className: saving ? 'bi bi-hourglass-split' : 'bi bi-floppy'
              })
            })]
          })
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: "col-3 col-md-12 pt-md-3 px-0",
          children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
            className: "editor-tabs btn-group w-100",
            role: "group",
            "aria-label": "Editor tools",
            children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("button", {
              className: activeTab === 'colors' ? 'btn bg-green' : 'btn bg-beige',
              type: "button",
              onClick: () => onTabChange('colors'),
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("i", {
                className: "bi bi-palette"
              }), " ", /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                className: "desktop-only",
                children: "Colors"
              })]
            }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("button", {
              className: activeTab === 'crop' ? 'btn bg-green' : 'btn bg-beige',
              type: "button",
              onClick: () => onTabChange('crop'),
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("i", {
                className: "bi bi-crop"
              }), " ", /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
                className: "desktop-only",
                children: "Crop"
              })]
            })]
          })
        })]
      })
    }), activeTab === 'colors' ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_AdvancedToggle.AdvancedToggle, {
        checked: editState.mode === 'advanced',
        onChange: checked => onModeChange(checked ? 'advanced' : 'basic')
      }), editState.mode === 'basic' ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_FilterSelector.FilterSelector, {
        crop: editState.crop,
        image: image,
        selectedFilter: editState.filter,
        onSelect: onFilterChange
      }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_AdjustmentControls.AdjustmentControls, {
        adjustments: editState.adjustments,
        onChange: onAdjustmentChange
      })]
    }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_CropControls.CropControls, {
      crop: stagedCrop,
      onChange: onCropChange
    })]
  });
};
exports.EditMenu = EditMenu;